import { useEffect, useState } from "react";
import { Button, CircularProgress, Paper, Typography } from "@mui/material";

type ChangeParamsType = {
  target: { value: any; name: string };
  name: string;
};
import { useForm, useWatch } from "react-hook-form";

import { useMutation } from "react-query";

import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { searchFields } from "../../Insurance/ClaimListing/fieldData";
// import { getPostOffice } from "../../Insurance/PriorApprovalDashboard/services";
import {
  InsuranceWiseOutStandingReportService,
  InsuranceWiseOutStandingSearchReportService,
} from "./services";
import usePopup from "../../hooks/usePopup";
import usePrint from "../../hooks/usePrint";
import { clinicId } from "../../constants";
import TableComponent from "../component/TableComponent";
import {getInsuranceType as getAllinsuranceType , getInsuranceByParams} from "../../Insurance/services"
const fieldsForClear = [
  searchFields.insuranceType.name,
  searchFields.insuranceTpaName.name,
  searchFields.insuranceName.name,
  searchFields.insurancePlan.name,
];
function Search() {
  const [filter, setFilter] = useState<any>(null);
  const {
    watch,
    control,
    getValues,
    resetField,
    register,
    reset,
    handleSubmit,
  } = useForm({ mode: "onChange" });

  const watchedValues = useWatch({ control });

  useEffect(() => {
    setIsDisabled(true);
  }, [watchedValues]);

  const { showSnackbar } = usePopup();
  const { printPdf } = usePrint();
  const [isDisabled, setIsDisabled] = useState(true);
  const insType = watch(searchFields.insuranceType.name);
  const {
    mutate: getInsuranceType,
    data: insuranceType,
    isLoading: insuranceTypeLoading,
  } = useMutation(getAllinsuranceType);
  const {
    mutate: getReveiverByType,
    data: receiver,
    isLoading: receiverLoadig,
  } = useMutation(getInsuranceByParams);

  const {
    mutate: getPayerByType,
    data: payer,
    isLoading: payerLoadig,
  } = useMutation(getInsuranceByParams);

  // const {
  //   mutate: fetchPostOffice,
  //   data: postOffice,
  //   isLoading: postOfficeLoading,
  // } = useMutation(getPostOffice);

  const { mutate: downloadReport, isLoading: reportLoading } = useMutation(
    InsuranceWiseOutStandingReportService,
    {
      onSuccess: (data) => {
        data.responseIndicator == "success" && printPdf(data.response);
      },
      onError: () => {
        showSnackbar({
          message: "Download Failed",
          open: true,
          variant: "error",
          duration: 2000,
        });
      },
    }
  );

  const {
    mutate: search,
    isLoading: searchLoading,
    data: searchData,
    reset: resetMutation,
  } = useMutation(InsuranceWiseOutStandingSearchReportService, {
    onSuccess: () => setIsDisabled(false),
  });

  const clearField = (index: number) => {
    for (let i = index; i < fieldsForClear.length; i++) {
      resetField(fieldsForClear[i]);
    }
  };

  function onSubmit(value: any, type: string) {
    const formData = {
      startDate: value[searchFields.fromDate.name],
      endDate: value[searchFields.toDate.name],
      // postOfficeId: value[searchFields.Postoffice.name].po_id,
      insuranceType: value[searchFields.insuranceType.name]?.name || null,
      receiver:
        value[searchFields.insuranceTpaName.name]?.name ||
        value[searchFields.insuranceName.name]?.name ||
        null,
      payer: value[searchFields.insuranceName.name]?.name || null,
      clinicId,
    };

    if (type == "pdf") {
      downloadReport(formData);
    } else {
      search(formData);
    }
  }

  const handleInsurnceTypeChange = (params: ChangeParamsType) => {
    const {
      target: { value },
    } = params;
    clearField(1);
    const allData = watch();
    if (Boolean(value)) {
      if (value.id == 1) {
        getReveiverByType({
         typeId:value?.id
        });
      } else {
        getPayerByType({
         typeId:value?.id
        });
      }
      setFilter((prev: any) => ({
        ...prev,
      }));
      reset({
        ...allData,
      });
    } else {
      setFilter((prev: any) => ({
        ...prev,
      }));
      reset({
        ...allData,
        [searchFields.insuranceType.name]: null,
      });
    }
  };

  const handleInsurnceNameChange = (_: ChangeParamsType) => {
    let params: any = {};
    if (insType.id == 1) {
      params = {
        searchText: "",
        insType: getValues(searchFields.insuranceType.name).id,
        insName: getValues(searchFields.insuranceTpaName.name).id,
        insGroup: getValues(searchFields.insuranceName.name).id,
      };
    } else {
      params = {
        searchText: "",
        insType: getValues(searchFields.insuranceType.name).id,
        insName: getValues(searchFields.insuranceName.name).id,
      };
    }
    console.log(params);
  };

  const handleReset = () => {
    reset({
      [searchFields.Postoffice.name]: { po_name: "Riayati", po_id: 1 },
    });
    setFilter((prev: any) => ({
      ...prev,
    }));
    resetMutation();
  };

  const handleSelectAll = (e: ChangeParamsType) => {
    const { target } = e;
    const details = watch();
    setFilter({
      ...filter,
    });
    if (target.value) {
      reset({
        ...details,
        [searchFields.insuranceType.name]: null,
        [searchFields.insuranceTpaName.name]: null,
        [searchFields.insuranceName.name]: null,
        [searchFields.insurancePlan.name]: null,
      });
      register(searchFields.insuranceType.name, { required: false });
      register(searchFields.insuranceTpaName.name, { required: false });
      register(searchFields.insuranceName.name, { required: false });
    } else {
      register(searchFields.insuranceType.name, {
        required: searchFields.insuranceType.name,
      });
      register(searchFields.insuranceTpaName.name, {
        required: searchFields.insuranceTpaName.name,
      });
      register(searchFields.insuranceName.name, {
        required: searchFields.insuranceName.name,
      });
    }
  };

  useEffect(() => {
    // fetchPostOffice();
    reset({
      [searchFields.Postoffice.name]: { po_name: "Riayati", po_id: 1 },
    });
    getInsuranceType();
  }, []);

  return (
    <div>
      <Paper className="p-2">
        <div className="py-3 border-b">
          <Typography
            margin={0}
            color="primary"
            fontWeight={600}
            fontSize={"1rem"}
          >
            Insurance wise Oustanding report
          </Typography>
        </div>

        <form
          onSubmit={handleSubmit((values) => onSubmit(values, "search"))}
          className="grid grid-cols-12 gap-3 pt-4"
        >
          <div className="col-span-3">
            {" "}
            <CustomFormField control={control} {...searchFields.fromDate} />
          </div>
          <div className="col-span-3">
            {" "}
            <CustomFormField control={control} {...searchFields.toDate} />
          </div>
          <div className="col-span-3">
            <CustomFormField
              control={control}
              options={insuranceType?.response || []}
              loading={insuranceTypeLoading}
              {...searchFields.insuranceType}
              rules={{
                ...searchFields.insuranceType.rules,
                required: filter?.all
                  ? false
                  : searchFields.insuranceType.rules.required,
                onChange: handleInsurnceTypeChange,
              }}
            />
          </div>
          <div className={insType?.id == 1 ? "col-span-3" : "hidden"}>
            <CustomFormField
              control={control}
              options={receiver?.response || []}
              loading={receiverLoadig}
              {...searchFields.insuranceTpaName}
              rules={{
                ...searchFields.insuranceTpaName.rules,
                required:
                  insType?.id == 1
                    ? searchFields.insuranceTpaName.rules.required
                    : false,
                onChange: () => {
                  clearField(2);
                  getPayerByType({
                    typeId:2
                  });
                },
              }}
            />
          </div>
          <div className="col-span-3">
            <CustomFormField
              control={control}
              options={payer?.response || []}
              loading={payerLoadig}
              {...searchFields.insuranceName}
              fieldProps={{
                label:
                  insType?.id == 1
                    ? searchFields.insuranceName.fieldProps.label
                    : "Insurance",
              }}
              rules={{
                ...searchFields.insuranceName.rules,
                required: filter?.all
                  ? false
                  : searchFields.insuranceName.rules.required,
                onChange: handleInsurnceNameChange,
              }}
            />
          </div>
          {/* <CustomFormField
            control={control}
            options={plans || []}
            loading={plansLoading}
            {...searchFields.insurancePlan}
          /> */}
          {/* <div className="col-span-3">
              <CustomFormField
                control={control}
                {...searchFields.Postoffice}
                options={postOffice || []}
                loading={postOfficeLoading}
              />
         </div> */}
          <div className="hidden">
            <CustomFormField
              control={control}
              {...searchFields?.all}
              rules={{ ...searchFields?.all?.rules, onChange: handleSelectAll }}
            />
          </div>

          <div
            className={
              insType?.id == 1
                ? "col-span-6 flex justify-end gap-2 items-center"
                : "col-span-9 flex justify-end gap-2 items-center"
            }
          >
            <Button
              endIcon={
                searchLoading && (
                  <CircularProgress
                    sx={{ color: (theme) => theme.palette.background.paper }}
                    size={18}
                  />
                )
              }
              size="small"
              type="submit"
            >
              Search
            </Button>
            <Button
              size="small"
              disabled={isDisabled}
              onClick={() => onSubmit(getValues(), "pdf")}
              endIcon={
                reportLoading && (
                  <CircularProgress
                    sx={{ color: (theme) => theme.palette.background.paper }}
                    size={18}
                  />
                )
              }
            >
              pdf
            </Button>
            <Button
              onClick={handleReset}
              size="small"
              type="reset"
              color="error"
            >
              clear
            </Button>
          </div>
        </form>

        <div className="my-3">
          <TableComponent
            loading={searchLoading}
            data={searchData?.response || []}
            tableProps={heading}
          />
        </div>
      </Paper>
    </div>
  );
}

export default Search;
const heading = [
  { heading: "Receiver", key: "receiver" },
  { heading: "Claim Submitted Date", key: "claimSubmittedDate", date: true },
  { heading: "Name", key: "Name" },
  { heading: "Claim Submit ID", key: "claimSubmitId" },
  { heading: "Days", key: "days" },
  { heading: "Claim ID", key: "claim_id" },
  { heading: "Phone No", key: "phnNo" },
  { heading: "Insurance Type", key: "insuranceType" },
  { heading: "Insurance Share", key: "insuranceShare" },
  { heading: "Payer", key: "payer" },
];
